import { useEffect, useState } from 'react';
import { InputNumber, InputSize } from '@ui/src';
import { AnnualIncomeTypes } from './types';
import InfoRow from '../../common/info-row';
import { NewApplicationStatus } from '../../../../hoc/new-application/types';

const AnnualIncome = ({
  id,
  name,
  questionnarieClearErrors,
  isEditable,
  status,
  annualIncomesValues,
  questionnarieSetValue,
  annualIncomesValue,
}: AnnualIncomeTypes) => {
  const [formValues, setFormValues] = useState<{
    sourceOfAnnualIncomeId: string;
    percentage?: string | number;
  }>({
    sourceOfAnnualIncomeId: '',
  });

  useEffect(() => {
    if (annualIncomesValue) {
      setFormValues(annualIncomesValue);
    } else {
      setFormValues({
        sourceOfAnnualIncomeId: id,
        percentage: '',
      });
    }
  }, [annualIncomesValue, id]);

  return (
    <InfoRow title={name} lessPadding>
      <InputNumber
        name={id}
        placeholder="Enter percent..."
        value={formValues?.percentage}
        size={InputSize.SMALL}
        onChange={(e) => {
          questionnarieClearErrors(['sourcesOfAnnualIncomes']);

          const nextFormValues = { ...formValues };

          let nextAnnualIncomeValues: {
            sourceOfAnnualIncomeId: string;
            percentage?: string | number;
          }[] = [];

          if (annualIncomesValues) {
            nextAnnualIncomeValues = (
              [] as {
                sourceOfAnnualIncomeId: string;
                percentage?: string | number;
              }[]
            ).concat(annualIncomesValues);
          }

          if (Number(e.target.value) < 0) {
            nextFormValues.percentage = 0;
          } else if (Number(e.target.value) >= 100) {
            nextAnnualIncomeValues = nextAnnualIncomeValues?.map((item) => {
              const result = { ...item };

              if (
                result.sourceOfAnnualIncomeId !==
                formValues.sourceOfAnnualIncomeId
              ) {
                result.percentage = '';
              }

              return result;
            });

            nextFormValues.percentage = 100;
          } else {
            nextFormValues.percentage = Number(e.target.value);
          }

          if (
            !nextAnnualIncomeValues.find(
              (item) =>
                item.sourceOfAnnualIncomeId ===
                formValues.sourceOfAnnualIncomeId,
            )
          ) {
            nextAnnualIncomeValues.push(nextFormValues);
          } else if (
            nextAnnualIncomeValues.find(
              (item) =>
                item.sourceOfAnnualIncomeId ===
                formValues.sourceOfAnnualIncomeId,
            )
          ) {
            nextAnnualIncomeValues = nextAnnualIncomeValues?.map((item) => {
              const result = { ...item };

              if (
                result.sourceOfAnnualIncomeId ===
                formValues.sourceOfAnnualIncomeId
              ) {
                result.percentage = Number(e.target.value);
              }

              return result;
            });
          }

          setFormValues(nextFormValues);

          questionnarieSetValue(
            'sourcesOfAnnualIncomes',
            nextAnnualIncomeValues as {
              sourceOfAnnualIncomeId: string;
              percentage?: string | number;
            }[],
          );
        }}
        className="borderless"
        disabled={
          !isEditable ||
          Boolean(
            status === NewApplicationStatus.ACCEPTED ||
            status === NewApplicationStatus.DECLINED,
          )
        }
        tabIndex={
          !isEditable &&
          Boolean(
            status === NewApplicationStatus.ACCEPTED ||
            status === NewApplicationStatus.DECLINED,
          )
            ? -1
            : 0
        }
      />
    </InfoRow>
  );
};

export default AnnualIncome;
